/**
 * TileMapLayer parser, which extends the Node2D base parse.
 */
import { parseNode2D } from '../../../base/node2d/parser';
import { boolOr } from '../../../../parser/valueParsers';
import { decodeTileMapData } from '../shared/tileData';
import { renderingQuadrantSizeOr } from '../shared/renderingQuadrantSize';
export function parseTileMapLayer(heading, properties) {
    const baseProperties = parseNode2D(heading, properties);
    const result = {
        ...baseProperties,
        enabled: boolOr(properties.enabled, true),
        rendering_quadrant_size: renderingQuadrantSizeOr(properties.rendering_quadrant_size),
    };
    if (properties.tile_set)
        result.tile_set = properties.tile_set;
    if (properties.tile_map_data)
        result.cells = decodeTileMapData(properties.tile_map_data);
    return result;
}
//# sourceMappingURL=parser.js.map